import "./App.css";

import { RecoilRoot } from "recoil";
import OpdcMap from "./map/OpdcMap";

import React, { useState, useEffect } from "react";

import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import MobileDrawer from "./drawer/MobileDrawer";
import { useMediaQuery, useTheme } from "@mui/material";
import DesktopDrawer from "./drawer/DesktopDrawer";
import { ThemeProvider } from "@mui/material/styles";
import { darkTheme, drawerBleeding, drawerWidth } from "./base/theme";
import { RecoilURLSyncJSON } from "recoil-sync";
import { useMap } from "react-map-gl";

const Root = styled("main")(() => ({
  height: "100%",
  width: "100%",
  maxHeight: "100%",
  maxWidth: "100%",
}));

const MapContainer = styled("div", {
  shouldForwardProp: (prop) =>
    prop !== "open" && prop !== "isMobile" && prop !== "isTouchDevice",
})(({ theme, open, isMobile, isTouchDevice }) => ({
  position: "absolute",
  height: isMobile && open && !isTouchDevice ? "50%" : "100%",
  width:
    open && !isMobile
      ? `calc(100% - ${drawerWidth - drawerBleeding}px)`
      : "100%",
  transition: theme.transitions.create(["width", "height"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  top: 0,
  left: 0,
  right: 0,
}));

function App() {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTouchDevice = "ontouchstart" in window || navigator.msMaxTouchPoints;
  const { map } = useMap();

  const handleSetDrawerOpen = async (newDrawerOpen) => {
    setDrawerOpen(newDrawerOpen);

    if (newDrawerOpen) {
      setTimeout(resizeMap, theme.transitions.duration.enteringScreen);
      return;
    }
    const resizeMapInterval = setInterval(resizeMap, 10);
    setTimeout(
      () => clearInterval(resizeMapInterval),
      theme.transitions.duration.leavingScreen + 500
    );
  };

  const resizeMap = () => {
    if (map) {
      map.resize();
    }
  };

  useEffect(() => {
    if (map) {
      map.resize();
    }
  }, [map, isMobile]);

  return (
    <RecoilRoot>
      <RecoilURLSyncJSON location={{ part: "queryParams" }}>
        <ThemeProvider theme={darkTheme}>
          <Root>
            <CssBaseline />
            <MapContainer
              open={drawerOpen}
              isMobile={isMobile}
              isTouchDevice={isTouchDevice}
            >
              <OpdcMap />
            </MapContainer>
            {isMobile ? (
              <MobileDrawer open={drawerOpen} setOpen={handleSetDrawerOpen} />
            ) : (
              <DesktopDrawer open={drawerOpen} setOpen={handleSetDrawerOpen} />
            )}
          </Root>
        </ThemeProvider>
      </RecoilURLSyncJSON>
    </RecoilRoot>
  );
}

export default App;

// To do:

// implement turning on of of individual layers
